// BTDateComponent
import { TextField } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import dayjs, { Dayjs } from 'dayjs';
import { useRef } from 'react';

interface BTDateComponentProps {
    value: string;
    onChange: (value: string) => void;
    disabled?: boolean;
    readOnly?: boolean;
    sx?: object;
    label?: string;
    width?: string | number;
}

export const BTDateComponent: React.FC<BTDateComponentProps> = ({
    value,
    onChange,
    disabled = false,
    readOnly = false,
    sx = {},
    label,
    width,
}) => {
    const dateValue: Dayjs | null = value ? dayjs(value) : null;
    const anchorRef = useRef<HTMLDivElement>(null);

    const handleChange = (newValue: Dayjs | null) => {
        if (!readOnly) {
            const formattedValue = newValue ? newValue.format('YYYY-MM-DD') : '';
            onChange(formattedValue);
        }
    };

    return (
        <div ref={anchorRef} style={{ position: 'relative', width: width ? (typeof width === 'number' ? `${width}px` : width) : '100%' }}>
            <DatePicker
                label={label}
                value={dateValue}
                onChange={handleChange}
                disabled={disabled || readOnly}
                slots={{
                    textField: (params) => (
                        <TextField
                            {...params}
                            inputRef={params.inputRef}
                            fullWidth
                            size="small"
                            sx={{
                                width: '100%',
                                height: '44px',
                                borderRadius: '4px',
                                backgroundColor: 'white',
                                fontSize: '16px',
                                '& .MuiInputBase-root': {
                                    height: '44px',
                                },
                                '& input': {
                                    padding: '10px',
                                },
                                ...sx,
                            }}
                        />
                    ),
                }}
                slotProps={{
                    popper: {
                        anchorEl: anchorRef.current,
                        placement: 'bottom-start',
                        disablePortal: false,
                        modifiers: [
                            {
                                name: 'flip',
                                enabled: true,
                            },
                            {
                                name: 'preventOverflow',
                                enabled: true,
                                options: {
                                    altAxis: true,
                                    altBoundary: true,
                                    tether: true,
                                    rootBoundary: 'viewport',
                                    padding: 8,
                                },
                            },
                            {
                                name: 'offset',
                                options: {
                                    offset: [0, 4],
                                },
                            },
                        ],
                    },
                }}
            />
        </div>
    );
};